import { render, staticRenderFns } from "./PackagesDropdown.vue?vue&type=template&id=b6251cfc"
import script from "./PackagesDropdown.vue?vue&type=script&lang=js"
export * from "./PackagesDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports